/**
 * ReadyUndoAllBar — „Alles rückgängig"-Aktion im Ergebnis-Panel (T13/P2, E5-
 * Follow-up). Ausgelagert aus `ReadyResultPanel.tsx` wegen des
 * Component-Size-Limits.
 */
import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

export interface ReadyUndoAllBarProps {
  busy: boolean
  undoResult: { reverted: number; noPrevious: number } | null
  onUndoAll: () => void
}

export function ReadyUndoAllBar({ busy, undoResult, onUndoAll }: ReadyUndoAllBarProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-2 border-t border-neutral-200 pt-2 dark:border-neutral-800">
      <button
        type="button"
        id={EID['text-bulk-ready-undo-all-btn']}
        disabled={busy}
        onClick={onUndoAll}
        className="rounded-md border border-neutral-300 px-2.5 py-1.5 text-xs font-medium text-neutral-700 hover:bg-neutral-50 disabled:opacity-50 dark:border-neutral-700 dark:text-neutral-300 dark:hover:bg-neutral-800"
      >
        {t('channelContent.ready.undoAll', 'Alles rückgängig')}
      </button>
      {undoResult && undoResult.noPrevious > 0 && (
        <span className="text-xs text-neutral-500 dark:text-neutral-400">
          {t('channelContent.ready.undoNoPrevious', '{{count}} Felder waren vorher leer und wurden nicht zurückgesetzt', {
            count: undoResult.noPrevious,
          })}
        </span>
      )}
    </div>
  )
}
